import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-navy px-4 text-center">
          <div>
            <h1 className="font-display text-3xl font-extrabold text-white">
              Something went wrong.
            </h1>
            <p className="mt-3 text-slate-300">
              Please refresh the page. If the problem continues, email{" "}
              <a
                className="text-skyblue underline"
                href="mailto:zach@webpilot.agency"
              >
                zach@webpilot.agency
              </a>
              .
            </p>
            <a
              href="/"
              data-testid="error-back-home-button"
              className="mt-8 inline-flex min-h-12 items-center rounded-lg bg-cta px-6 py-3 font-display font-bold text-white transition-colors hover:bg-cta-hover"
            >
              Back to home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
